<template>
    <Breadcrumbs main="Ville" :mains="title" title="Accueil" />
    <div class="container-fluid">
        <div class="row">
            <Card3 colClass="col-sm-12">
                <TownEdit :town="town" />
                <div class="row">
                    <div class="col">
                        <div class="text-end">
                            <a
                                class="btn btn-success me-1"
                                target="_blank"
                                @click="save()"
                                >{{ $t('save') }}</a
                            >
                        </div>
                    </div>
                </div>
            </Card3>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { useRoute } from 'vue-router';
import config from '@/config';
let route = useRoute();
import { ref, defineAsyncComponent, onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { error_message, success_message } from '@/components/common/toast';
import ApiServices from '@/services/apiServices';
import { useLoaderState } from '@/store/loading';
import type { town } from '@/core/data/town';
const { t } = useI18n();
const TownEdit = defineAsyncComponent(
    () => import('@/components/theme/town/TownEdit.vue'),
);
let town = ref<town>({
    id: '',
    name: '',
    latitude: '',
    longitude: '',
    apiKey: '',
    createdBy: undefined,
    createdAt: undefined,
    updatedBy: undefined,
    updatedAt: undefined,
    status: 'ACTIVE',
});

const title = computed(() => {
    return town.value && town.value.id
        ? t('townEdit.updatetitle')
        : t('townEdit.addtitle');
});
const save = async () => {
    if (!town.value.name || !town.value.latitude || !town.value.longitude) {
        error_message(t('townEdit.requiredFields'));
        return;
    }
    useLoaderState().changeStateTrue();
    if (route.query.id !== undefined) {
        //@ts-ignore
        ApiServices.update('town', town.value, town.value.id)
            .then(() => {
                success_message(t('townEdit.updated'));
            })
            .catch((ex) => {
                error_message(ex);
            })
            .finally(() => {
                useLoaderState().changeStateFalse();
            });
    } else {
        ApiServices.create('town', town.value)
            .then(() => {
                success_message(t('townEdit.saved'));
            })
            .catch((ex) => {
                error_message(ex);
            })
            .finally(() => {
                useLoaderState().changeStateFalse();
            });
    }
};
const getDatas = async () => {
    if (route.query.id !== undefined) {
        ApiServices.getById('town', route.query.id.toString()).then(
            (response: any) => {
                town.value = response;
            },
        );
    }
};
onMounted(() => {
    useLoaderState().changeStateTrue();
    getDatas();
    useLoaderState().changeStateFalse();
});
</script>